import React, { useEffect } from "react";
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/header/Header";
import SpaceFilterContainer from "../../containers/st/SpaceFilterContainer";
import { useState } from "react";
import { setStDelFilterAction, setStFilterChangeAction } from "../../modules/st/stContentsModule";
import SpaceContentsList from "../../components/st/SpaceContentsList";
import TagBtn from "../../components/common/button/TagBtn";
import { useRef } from "react";
import { union, reduce, result, indexOf, concat, countBy, filter, forEach } from "lodash";

import {isMobileOnly} from 'react-device-detect';

const SpaceMainBlock = styled.div``;

const SpaceContentsBlock = styled.div`
    //width: 100%;
    max-width: 1176px;
    //margin: 0 auto;
    ${isMobileOnly?`
        margin: 0 4vw;
    `:`
        width: 100%;
        margin: 0 auto;
    `};
    padding-top: 80px
`;

const SpaceSmallSectionBlock = styled.div`
    padding: 30px 0 160px;
    width: 100%;
    max-width: 1176px;
`;

const SpaceFilterBoxBlock = styled.div`
    border-top: 2px solid #111;
`;

const SpaceFilterSzWrapBlock = styled.div`
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const SpaceFilterResetBlock = styled.button`
    display: block;
    margin: 0 0 10px auto;
    color: #999;
    font-size: 14px;
`;

const SpaceFilterStickyBlock = styled.div`
    display: ${prods => prods.display || 'none'};
    position: fixed;
    top: ${isMobileOnly?'60px':'80px'};
    left: 0;
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #e7e7e7;
    z-index: 10;
    text-align: center;
    padding: 10px;

    .sz-wrap {
        display: inline-block;
        width: auto;
        vertical-align: bottom;
    }

    .full-wrap {
        display: block;
    }

    .clearfix::after {
        content: "";
        display: block;
        clear: both;
    }

    .fs-box {
        width: calc(100% - 100px);
    }

    .f-left {
        float: left;
    }
`;

const SpaceMain = () => {
    const dispatch = useDispatch();
    const [reset, setReset] = useState(false);
    const [tagFilter, setTagFilter] = useState(null);
    const [curPrice, setCurPrice] = useState(null);

    const { stDelFilterInfo, stFilterInfo, curMenu, maxPrice, minPrice, curPriceRedux, curMinMaxPrice } = useSelector(
        ({ stContentsReducer, stFilterReducer, headerReducer }) => ({
            stDelFilterInfo: stContentsReducer.stDelFilterInfo,
            stFilterInfo: stFilterReducer.stFilterInfo,
            curMenu: headerReducer.curMenu,
            minPrice: stContentsReducer.minPrice,
            maxPrice: stContentsReducer.maxPrice,
            curPriceRedux: stContentsReducer.curPrice,
            curMinMaxPrice: stContentsReducer.curMinMaxPrice,
        })
    );

    const [filterSticky, setFilterSticky] = useState(false);

    // 최소 실행시 Header 관련 처리 추가
    useEffect(() => {

        if (curMenu !== 'st') {
            window.scrollTo(0, 0);
        }
        // console.log("curMenu : " + curMenu);

        dispatch(setCurMenuAction('st'));
        dispatch(setHeaderTransferAction(false));

        if (stFilterInfo !== null && stFilterInfo !== undefined) {

            let tagfilter0 =  reduce(stFilterInfo[0], function (result, curfilter, key) {

                if (curfilter.filter2_id * 1 !== 0) {
                    let code = curfilter.filter1_id * 100 + curfilter.filter2_id * 1;

                    let idx = indexOf(stDelFilterInfo, code);
                    if (idx === -1) {
                        result.push({ code: code, name: curfilter.filter_name });
                    }
                }
                return result;
            }, [])

            let tagfilter1 =  reduce(stFilterInfo[1], function (result, curfilter, key) {

                if (curfilter.filter2_id * 1 !== 0) {
                    let code = curfilter.filter1_id * 100 + curfilter.filter2_id * 1;

                    let idx = indexOf(stDelFilterInfo, code);
                    if (idx === -1) {
                        result.push({ code: code, name: curfilter.filter_name });
                    }
                }
                return result;
            }, [])

            let tagfilter2 =  reduce(stFilterInfo[2], function (result, curfilter, key) {

                if (curfilter.filter2_id * 1 !== 0) {
                    let code = curfilter.filter1_id * 100 + curfilter.filter2_id * 1;

                    let idx = indexOf(stDelFilterInfo, code);
                    if (idx === -1) {
                        result.push({ code: code, name: curfilter.filter_name });
                    }
                }
                return result;
            }, [])

            if(tagfilter0 !== null && stFilterInfo[0].length === tagfilter0.length + 1){
                let curfilter = filter(stFilterInfo[0], (curid) => {
                    //console.log("curid = " + JSON.stringify(curid))
                    return curid.filter2_id*1 === 0;
                })
                //console.log("curfilter = " + JSON.stringify(curfilter))
                tagfilter0 = [];
                let name = curfilter[0].filter_name+'전체';
                tagfilter0.push({ code: -1, name: name });
                //console.log("tagfilter0 = " + JSON.stringify(tagfilter0))
            }

            if(tagfilter1 !== null && stFilterInfo[1].length === tagfilter1.length + 1){
                let curfilter = filter(stFilterInfo[1], (curid) => {
                   return curid.filter2_id*1 === 0;
               })
               tagfilter1 = [];
               let name = curfilter[0].filter_name+'전체';
               tagfilter1.push({ code: -2, name: name});
            }

            if(tagfilter2 !== null && stFilterInfo[2].length === tagfilter2.length + 1){
                let curfilter = filter(stFilterInfo[2], (curid) => {
                   return curid.filter2_id*1 === 0;
               })
               tagfilter2 = [];
               let name = curfilter[0].filter_name+'전체';
               tagfilter2.push({ code: -3, name: name});
            }

            let tagfilter = union(tagfilter0, tagfilter1, tagfilter2);
            // filter 배열  합치기
            //let unionFilter = union(stFilterInfo[0], stFilterInfo[1], stFilterInfo[2]);
             /* console.log("unionFilter : " + JSON.stringify(unionFilter))

            let tagfilter = reduce(unionFilter, function (result, curfilter, key) {

                if (curfilter.filter2_id * 1 !== 0) {
                    let code = curfilter.filter1_id * 100 + curfilter.filter2_id * 1;

                    let idx = indexOf(stDelFilterInfo, code);
                    if (idx === -1) {
                        result.push({ code: code, name: curfilter.filter_name });
                    }
                }
                return result;
            }, []) */

            setTagFilter(tagfilter);

            // console.log("tagfilter : " + JSON.stringify(tagfilter))
        }

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);

    }, [stDelFilterInfo, stFilterInfo]);

    useEffect(() => {
        if (curMinMaxPrice[0] === curPriceRedux[0] && curMinMaxPrice[1] === curPriceRedux[1]) {
            setCurPrice('가격전체');
        }
        else{
            let strPrice = Number(curPriceRedux[0].toFixed(1)).toLocaleString();
                strPrice += '원 ~ ';
                strPrice += Number(curPriceRedux[1].toFixed(1)).toLocaleString();
                strPrice += '원';
                setCurPrice(strPrice);
        }
    }, [curPriceRedux ]);

    const handleReset = () => {
        if (stFilterInfo !== null && stFilterInfo.length > 0) {
            let stDelFilter = [];
            forEach(stFilterInfo, (item, idx) => {
                let arrFilter = filter(item, function (curitem, idx) {
                    return idx !== 0;
                });

                arrFilter.map((item) => {
                    let filtervalue = item.filter1_id * 100 + item.filter2_id * 1;
                    stDelFilter = concat(stDelFilter, filtervalue);
                })
            })
            dispatch(setStFilterChangeAction(true));
            dispatch(setStDelFilterAction(stDelFilter))
        }
        //dispatch(setStDelFilterAction([]));
        setReset(!reset);
    }

    const handlerFilterClick = (value) => {
        // console.log("value : " + value);

        let checkcnt = Math.floor(value / 100);

        // 각 항목별 필터가 1개만 남은 경우 삭제 안됨
        let unionFilter = union(stFilterInfo[0], stFilterInfo[1], stFilterInfo[2]);
        // 전체 필터별 통계치 계산
        let countbyfilter = countBy(unionFilter, function (curitem) {
            return curitem.filter1_id;
        })
        // console.log("countby : " + JSON.stringify(countbyfilter));

        // 삭제 태그로 등록된 통계치 계산
        let countbydel = countBy(stDelFilterInfo, function (curitem) {
            return Math.floor(curitem / 100);
        })
        // console.log("countbydel : " + countbyfilter["53"]);

        if (countbydel[checkcnt] !== null && countbydel[checkcnt] !== undefined) {
            try {

                // 전체 통계치와 삭제 통계치 비교
                let delcnt = countbydel[checkcnt];
                let filtercnt = countbyfilter[checkcnt]

                // console.log("delcnt : " + delcnt + " , filtercnt : " + filtercnt);

                // 전체 통계치에는 1 depth 제목도 포함되어 있으므로 -2 처리
                //if (delcnt < filtercnt - 2) {
                    let delfilter = concat(stDelFilterInfo, value);
                    // console.log("delfilter : " + JSON.stringify(delfilter))
                    dispatch(setStFilterChangeAction(true));
                    dispatch(setStDelFilterAction(delfilter));
                //}

            } catch (e) {
                // console.log("err : " + e);
            }


        } else {
            let delfilter = concat(stDelFilterInfo, value);
            dispatch(setStFilterChangeAction(true));
            dispatch(setStDelFilterAction(delfilter));
        }
    }

    const onScroll = () => {

        if (window.scrollY < 100) {
            setFilterSticky(false);
        } else {
            setFilterSticky(true);
        }
    };


    return (
        <SpaceMainBlock>
            <Header />
            <SpaceContentsBlock>
                <SpaceSmallSectionBlock>
                    <SpaceFilterStickyBlock display={filterSticky ? "block" : "none"}>
                        <div className="sz-wrap full-wrap clearfix">
                            <div className="fs-box11 f-left11" style={{ display: 'inline-block' }}>
                                {
                                    tagFilter === null ? '' :
                                        tagFilter.map((curtag) => {
                                            if(curtag.code*1 < 0 ){
                                                return (
                                                    <TagBtn
                                                        key={curtag.code}
                                                        active={true}
                                                        float='left'
                                                        margin={isMobileOnly?'0 5px':'0px 20px'}
                                                        onClick={handlerFilterClick}
                                                        onDelClick={handlerFilterClick}
                                                        noDelBtn = {curtag.code*1 < 0 ? 'true':'false'}
                                                        text={curtag.name} isSmall={true} value={curtag.code}
                                                    />
                                                )
                                            }
                                            else{
                                                return (
                                                    <TagBtn
                                                        key={curtag.code}
                                                        active={true}
                                                        float='left'
                                                        margin={isMobileOnly?'0 5px':'0px 20px'}
                                                        onClick={handlerFilterClick}
                                                        onDelClick={handlerFilterClick}
                                                        text={curtag.name} isSmall={true} value={curtag.code}
                                                    />
                                                )
                                            }
                                        })
                                }
                                <TagBtn
                                    key="-100"
                                    active={true}
                                    float='left'
                                    margin='0px 20px'
                                    onClick={handlerFilterClick}
                                    onDelClick={handlerFilterClick}
                                    noDelBtn = 'true'
                                    text={curPrice} isSmall={true} value={-100}
                                />
                            </div>
                        </div>
                    </SpaceFilterStickyBlock>
                    <SpaceFilterResetBlock onClick={handleReset}>
                        초기화
                    </SpaceFilterResetBlock>
                    <SpaceFilterBoxBlock>
                        <SpaceFilterSzWrapBlock>
                            <SpaceFilterContainer reset={reset} />
                        </SpaceFilterSzWrapBlock>
                    </SpaceFilterBoxBlock>
                    <SpaceContentsList />
                </SpaceSmallSectionBlock>
            </SpaceContentsBlock>
            <Footer />
        </SpaceMainBlock>
    );
};

export default SpaceMain;
